<template>
  <div class="earning-card">
    <div>
      <img
        v-if="value.rebateType === 'DIRECT'"
        class="earning-card-icon"
        src="@/assets/img/chargingVoucher/icon-profit.png"
      >
      <img
        v-else-if="value.rebateType === 'INDIRECT'"
        class="earning-card-icon"
        src="@/assets/img/chargingVoucher/icon-indirect-profit.png"
      >
    </div>
    <div class="earning-card-content">
      <div class="earning-card-content-title">
        {{ inComeTypeOptions[value.rebateType] || "" }}
      </div>
      <div class="earning-card-content-info">{{ value.createTime || "" }}</div>
    </div>
    <div class="earning-card-content1">
      <div class="earning-card-content-earning">
        +￥{{ value.rebate || "" }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EarningCard',
  props: {
    value: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      inComeTypeOptions: {
        DIRECT: '直接收益',
        INDIRECT: '间接收益'
      }
    };
  },
  methods: {}
};
</script>

<style lang="scss" scoped>
.earning-card {
  width: 100%;
  height: 150px;
  background: #ffffff;
  border-radius: 20px;
  box-sizing: border-box;
  padding: 16px 32px;
  display: flex;
  align-items: center;
  margin-bottom: 16px;

  .earning-card-icon {
    width: 48px;
    height: 48px;
    object-fit: contain;
    margin-right: 16px;
    vertical-align: top;
    margin-top: 2px;
  }
  .earning-card-content {
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    .earning-card-content-title {
      font-size: 32px;
      color: #383838;
      font-weight: 500;
      line-height: 45px;
      margin-bottom: 4px;
    }
    .earning-card-content-info {
      font-size: 28px;
      color: #787878;
      letter-spacing: 0.42px;
      font-weight: 400;
      margin-bottom: 4px;
      line-height: 40px;

      &:last-child {
        margin-bottom: 0;
      }
    }
  }
  .earning-card-content1 {
    text-align: right;
    flex: 1;
  }
  .earning-card-content-earning {
    font-size: 40px;
    color: #ff722c;
    font-weight: 500;
  }
}
</style>
